import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { forwardRef } from 'react';

import Form from 'UI/molecules/Form';

const IBANField = forwardRef((props, ref) => {
  const { t } = useTranslation('companyDataCard');

  const { errors, ...other } = props;

  return (
    <Form.Field>
      <Form.Label htmlFor="form_iban">
        {t('form.step3.iban.label')} *
      </Form.Label>
      <Form.Control>
        <Form.Input
          error={errors.iban}
          id="form_iban"
          name="iban"
          ref={ref}
          {...other}
          placeholder={t('form.step3.iban.placeholder')}
        />
        {errors.iban && <Form.Error>{errors.iban?.message}</Form.Error>}
      </Form.Control>
    </Form.Field>
  );
});

IBANField.displayName = 'IBANField';

IBANField.propTypes = {
  errors: PropTypes.object,
  disabled: PropTypes.bool,
};

export default IBANField;
